import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export const FAQ = () => {
  const faqs = [{
    q: '¿Voy a tener que dejar que mi bebé llore solo?',
    a: 'No. El método usa "Presencia Gradual". Tu bebé sabrá que estás ahí, pero aprenderá a no depender de tus brazos para dormir.'
  }, {
    q: '¿Funciona si doy pecho?',
    a: 'Absolutamente. El manual incluye cómo separar la alimentación del sueño sin afectar la lactancia.'
  }, {
    q: '¿Cuándo veré resultados?',
    a: 'La mayoría de las madres reportan el primer bloque de 5 horas de sueño en la segunda o tercera noche.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-6 bg-brand-cream" data-id="element-50">
      <div className="max-w-3xl mx-auto" data-id="element-51">
        <div className="text-center mb-12" data-id="element-52">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-4" data-id="element-53">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-54">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl shadow-sm border border-brand-lavender/10 overflow-hidden" data-id="element-55">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-56">
                <span className="font-bold text-lg text-brand-navy" data-id="element-57">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-lavender transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-58" />
              </button>
              <AnimatePresence data-id="element-59">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-60">
                    <div className="p-6 pt-0 text-brand-charcoal/80 leading-relaxed" data-id="element-61">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
};